/** Split / join project description paragraphs (blank-line separated). */

export function splitDescriptionParagraphs(text) {
  const raw = String(text || "")
    .replace(/\r\n/g, "\n")
    .trim();
  if (!raw) return ["", "", ""];
  let parts = raw
    .split(/\n\s*\n+/)
    .map((p) => p.trim())
    .filter(Boolean);
  if (parts.length <= 1 && raw.includes("\n")) {
    const lines = raw
      .split("\n")
      .map((ln) => ln.trim())
      .filter(Boolean);
    if (lines.length >= 3) parts = lines;
  }
  while (parts.length < 3) parts.push("");
  return parts.slice(0, 6);
}

export function joinDescriptionParagraphs(paragraphs) {
  return (Array.isArray(paragraphs) ? paragraphs : [])
    .map((p) => String(p || "").trim())
    .filter(Boolean)
    .join("\n\n");
}

export function countFilledParagraphs(paragraphs) {
  return (Array.isArray(paragraphs) ? paragraphs : []).filter((p) => String(p || "").trim()).length;
}

/** Best-effort embed URL for YouTube / Vimeo; otherwise null (show link). */
export function projectVideoEmbedSrc(url) {
  const raw = String(url || "").trim();
  if (!raw) return null;
  try {
    const u = new URL(raw);
    const host = u.hostname.replace(/^www\./, "");
    if (host === "youtu.be") {
      const id = u.pathname.replace(/^\//, "").split("/")[0];
      return id ? `https://www.youtube.com/embed/${id}` : null;
    }
    if (host === "youtube.com" || host === "m.youtube.com") {
      const id = u.searchParams.get("v") || (u.pathname.startsWith("/embed/") ? u.pathname.split("/")[2] : "");
      return id ? `https://www.youtube.com/embed/${id}` : null;
    }
    if (host === "vimeo.com") {
      const id = u.pathname.split("/").filter(Boolean)[0];
      return id && /^\d+$/.test(id) ? `https://player.vimeo.com/video/${id}` : null;
    }
  } catch {
    return null;
  }
  return null;
}
